/* tslint:disable */
/* eslint-disable */
export enum AccountAgreementType {
  TERMS_ACCEPTED = 'TERMS_ACCEPTED',
  PERSONAL_INFORMATION_COLLECTION_CONSENT = 'PERSONAL_INFORMATION_COLLECTION_CONSENT'
}
